import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { createFormData } from '../helpers/createFormdata';
import { getApiErrorMessage, toApiError } from '../utils';

export const useUpdateAvatarsDefensive = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ id, file }: { id: string; file: File[] }) => {
			try {
				const formData = createFormData({ file });
				await api.put(`/agricultural-defensives/updateAvatars/${id}`, formData);
			} catch (error) {
				throw toApiError(error, 'Erro ao atualizar avatar do defensivo');
			}
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: ['defensives'] });
			queryClient.invalidateQueries({ queryKey: ['defensive', variables.id] });
		},
		onError: (error) =>
			console.error(
				'Erro ao atualizar avatar do defensivo:',
				getApiErrorMessage(error, 'Erro ao atualizar avatar do defensivo')
			),
	});
};
